import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-busfacility',
  templateUrl: './busfacility.component.html',
  styleUrls: ['./busfacility.component.scss']
})
export class BusfacilityComponent implements OnInit {

  constructor(
      private meta: Meta,
      private titles: Title
  ) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Transport: Convenient and Reliable Campus Travel');
        this.meta.updateTag({
            name: 'description',
            content: `Discover ARNI Transport, offering safe and efficient transportation services for students and staff, ensuring easy access to and from the campus every day.`
        });
    }

}
